import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';
import { toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { printApiError, validate } from '@utils/Util';

const ResetPassword = () => {
	const [token, setToken] = useState('');
	const [password, setPassword] = useState('');
	const [loading, setLoading] = useState(false);
	const [passwordRe, setPasswordRe] = useState('');
	const [passwordError, setPasswordError] = useState('');
	const [passwordReError, setPasswordReError] = useState('');

	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const tokenFromUrl = queryParams.get('token');
		if (tokenFromUrl) {
			setToken(tokenFromUrl);
		}
	}, [location.search]);

	const onChange = (e) => {
		const { name, value } = e.target;
		const err = validate(e, password);
		if (name === 'password') {
			setPassword(value);
		} else if (name === 'passwordRe') {
			setPasswordRe(value);
		}
		setErrorState(err.name, err.value);
	};

	const setErrorState = (name, value) => {
		if (name === 'passwordError') setPasswordError(value);
		if (name === 'passwordReError') setPasswordReError(value);
	};

	const reset = () => {
		if (!passwordError && !passwordReError) {
			if (password && passwordRe) {
				setLoading(true);
				const body = {
					token,
					password,
					retypePassword: passwordRe
				};

				ApiClient.POST('completeForgotPassword', body)
					.then(({ data }) => {
						setLoading(false);
						if (data.success) {
							toastSuccess(data.message + '. Please login again with new password.');
							navigate('/login');
						}
					})
					.catch((error) => {
						setLoading(false);
						printApiError(error);
					});
			} else {
				if (!password) {
					setPasswordError('Password is required!');
				} else if (!passwordRe) {
					setPasswordReError('Please enter your password again!');
				}
			}
		}
	};

	return (
		<LoaderComponent loading={loading}>
			<section>
				<div className="container auth-page">
					<div className="row fullscreen justify-content-center align-items-center">
						<div className="col-7">
							<div className="section-header text-center">
								<h4 className="section-title">Create new password</h4>
								<p className="section-subtitle">
									Your password must be different from previously used passwords.
								</p>
							</div>
							<form className="registration-form mt-5 reset-pass">
								<div className="form-group">
									<div className="input-group">
										<input
											type="password"
											className="form-control"
											name="password"
											onChange={onChange}
											value={password}
											placeholder="New password"
										/>
										<div className="input-group-append">
											<span className="input-group-text">
												<img
													src={`${process.env.PUBLIC_URL}/images/icons/lock.png`}
													alt="password"
													className="img-fluid"
												/>
											</span>
										</div>
									</div>
									{passwordError && <p className="error">{passwordError}</p>}
								</div>
								<div className="form-group">
									<div className="input-group">
										<input
											type="password"
											className="form-control"
											name="passwordRe"
											onChange={onChange}
											value={passwordRe}
											placeholder="Re-enter new password"
										/>
										<div className="input-group-append">
											<span className="input-group-text">
												<img
													src={`${process.env.PUBLIC_URL}/images/icons/lock.png`}
													alt="password"
													className="img-fluid"
												/>
											</span>
										</div>
									</div>
									{passwordReError && <p className="error">{passwordReError}</p>}
								</div>
								<button
									type="button"
									className="btn btn-nitex-default btn-block mt-6"
									onClick={reset}
								>
									Create
								</button>
							</form>
						</div>
					</div>
				</div>
			</section>
		</LoaderComponent>
	);
};

export default ResetPassword;
